export default __webpack_public_path__ + "static/media/Dazzed-Thin.d3b7c669.otf";